/**
 * @callback runCb
 * @param {number} dd - number of days
 * @param {number} hh - number of hours
 * @param {number} mm - number of minutes
 * @param {number} ss - number of seconds
 * @returns {void}
 */
/**
 * @callback clearCb
 * @returns {void}
 */
/**
 * A function that counts down to an end time and runs a callback every second. Also takes in an optional callback when the timer ends.
 * The maximum resolution is days
 * @param {string} endDateString - The timer's end time in the format YYYY-MM-DDTHH:mm:ss.sssZ
 * @param {runCb} runCb - callback when timer ticks every second
 * @param {clearCb} [clearCb] - callback when timer ends
 * @throws Throws an error when the endDateString is invalid
 */
const countdownTimer = (endDateString, runCb, clearCb) => {
    const endDate = new Date(endDateString);

    if (endDate.toString() === 'Invalid Date') {
        throw Error('Invalid Date');
    }

    const intervalId = setInterval(() => {
        const currentDateTime = Date.now();
        const endDateTime = endDate.getTime();
        const timeDiffMs = endDateTime - currentDateTime;

        if (timeDiffMs < 0) {
            if (clearCb) {
                clearCb();
            }

            clearInterval(intervalId);
        } else {
            const DAY_MS = 86400000;
            const HOUR_MS = 3600000;
            const MINUTE_MS = 60000;
            const dd = Math.floor(timeDiffMs / DAY_MS);
            const hh = Math.floor((timeDiffMs % DAY_MS) / HOUR_MS);
            const mm = Math.floor((timeDiffMs % HOUR_MS) / MINUTE_MS);
            const ss = Math.floor((timeDiffMs % MINUTE_MS) / 1000);
            runCb(dd, hh, mm, ss);
        }
    }, 1000);
};

export default countdownTimer;
